// Copyright (C) 2021 TANNER AG

import React from "react";
import { compose } from "recompose";
import { withStyles } from "@material-ui/core/styles";
import { sharedComponentStyles } from "../screens/Component";
import MANInfo from "./MANInfo";
import DataTable from "../components/DataTable";
import Quote from "../components/Quote";
import { Heading3 } from "../styleguide";
import HeadingNumber from "./HeadingNumber";
import Grid from "@material-ui/core/Grid";
import EMobilitySlider from "./EMobilitySlider";
import { HEADER_HEIGHT } from "../layouts/Header";
import { NAVIGATION_HEIGHT } from "../layouts/Navigation";
import EMobilityHotspot from "./EMobilityHotspot";
import EMobilityContentImage from "./EMobilityContentImage";
import EMobilityVideo from "./EMobilityVideo";
import EMobilityMarkdown from "./EMobilityMarkdown";
import classnames from "classnames";
import { SUMMARY_BAR_HEIGHT } from "../components/SummaryBar";

const styles = (theme) => ({
    root: {
        marginTop: 20,
        marginBottom: 40,
    },
    containerStyle: {
        maxWidth: 1200,
        marginLeft: "auto",
        marginRight: "auto",
        position: "relative",
    },
    headlineStyle: {
        marginBottom: 20,
        position: "relative",
        fontSize: 28,

        "& > a": {
            position: "absolute",
            top: `-${HEADER_HEIGHT + NAVIGATION_HEIGHT}px`,
        },
    },
    headlineBarStyle: {
        "& > a": {
            top: `-${HEADER_HEIGHT + NAVIGATION_HEIGHT + SUMMARY_BAR_HEIGHT}px`,
        },
    }
});

const EMobilityContentItem = ({ classes, content, number, index, withNavBar }) => {
    const chapterNo = Boolean(number || content.order) ? `${number}.${content.order}` : "";
    const sliderAssets = Boolean(content.assetWithDescriptions && content.assetWithDescriptions.length);

    return (
            <div key={index} data-title={content.title} className={classes.root}>
                    <div className={classes.containerStyle}>
                        <Grid container spacing={16}>
                            {content.twoColumns && (
                                <Grid xs md={5}>
                                    <EMobilityContentImage image={content.image} />
                                </Grid>
                            )}
                            <Grid item xs md={Boolean(content.quote || content.twoColumns) ? 7 : 12}>
                                {content.title && (
                                    <Heading3 bold className={classnames(classes.headlineStyle, { [classes.headlineBarStyle]: withNavBar })}>
                                        {<a id={`chapter-${chapterNo || index}`} />}
                                        {chapterNo &&<HeadingNumber>{chapterNo}</HeadingNumber>}
                                        {content.title}
                                    </Heading3>
                                )}
                                {content.content && <EMobilityMarkdown content={content.content} />}
                                {content.table && <DataTable data={content.table} />}
                                {content.info && <MANInfo key={index} content={content.info} />}
                                {Boolean(content.hotspots && content.hotspots.length && content.image) && (
                                    <EMobilityHotspot image={content.image} hotspots={content.hotspots || []} />
                                )}
                                {content.youTubeLink && <EMobilityVideo src={content.youTubeLink} />}
                            </Grid>
                            {content.quote && (
                                <Grid item xs md={5} style={{ display: "flex", justifyContent: "flex-end" }}>
                                    <Quote content={content.quote} />
                                </Grid>
                            )}
                        </Grid>
                    </div>
                {sliderAssets && <EMobilitySlider medias={content.assetWithDescriptions} />}
            </div>
    );
};

export default compose(withStyles(sharedComponentStyles), withStyles(styles))(EMobilityContentItem);



// WEBPACK FOOTER //
// ./src/emobility/EMobilityContentItem.js